export default __webpack_public_path__ + "static/media/MRDOffIcon.aa529391.svg";